import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
        hasError: false, 
        errorMessage: '', 
        retryKey: 0,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state to indicate an error has occurred
    return { hasError: true, errorMessage: error.message };
  }

  componentDidCatch(error, info) {
    // You can also log the error to an error tracking service
    console.error('Error caught in Error Boundary:', error, info);
  }

  handleRetry = () => {
    this.setState(prevState => ({
        hasError: false,
        errorMessage: '',
        retryKey: prevState.retryKey + 1,
    }));
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <h2>Ein Fehler aufgetreten! Bitte versuchen Sie es nochmal.</h2>
          <p>{this.state.errorMessage}</p>
          <button onClick={this.handleRetry}>erneut versuchen</button>
        </div>
      );
    }

    //return React.cloneElement(this.props.children, { key: this.state.retryKey });
    // Wrap children with a key to force remount on retry
    return <div key={this.state.retryKey}>{this.props.children}</div>;
  }
}

export default ErrorBoundary;
